// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2tqpF","buttons":"Footer_buttons__1-NNB"};